(() => {
  const startsWith = (asset, controlArray = [ '//', 'http', 'mailto', 'sms', 'tel' ]) => {
    return controlArray.some(key => asset.startsWith(key));
  };

  if(!App.cdn) {
    console.assert(!!App.cdn, 'No cdn path find in App global');
    App.cdn = window.location.origin + '/';
  }

  window.cdnUrl = function(asset) {
    if (startsWith(asset)) {
      return asset;
    }

    return `${ App.cdn }${ asset.replace(/\/+/, '') }`;
  };
  window.assetUrl = function(asset) {
    if (startsWith(asset)) {
      return asset;
    }

    return `${ App.url }${ asset.replace(/\/+/, '') }`;
  };
})()
